import { render, staticRenderFns } from "./contest-submite.vue?vue&type=template&id=a119e3f6&scoped=true"
import script from "./contest-submite.vue?vue&type=script&lang=js"
export * from "./contest-submite.vue?vue&type=script&lang=js"
import style0 from "./contest-submite.vue?vue&type=style&index=0&id=a119e3f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a119e3f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a119e3f6')) {
      api.createRecord('a119e3f6', component.options)
    } else {
      api.reload('a119e3f6', component.options)
    }
    module.hot.accept("./contest-submite.vue?vue&type=template&id=a119e3f6&scoped=true", function () {
      api.rerender('a119e3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-submite.vue"
export default component.exports